import { render, staticRenderFns } from "./editdigi.vue?vue&type=template&id=06a8fde4&scoped=true"
import script from "./editdigi.vue?vue&type=script&lang=js"
export * from "./editdigi.vue?vue&type=script&lang=js"
import style0 from "./editdigi.vue?vue&type=style&index=0&id=06a8fde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8fde4",
  null
  
)

export default component.exports